import React from 'react';

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='30'
      height='30'
      viewBox='0 0 30 30'
    >
      <path d='M24.94 2.746a1 1 0 00-.78 1.639A17.282 17.282 0 0128 15.255c0 3.899-1.302 7.48-3.479 10.388a1 1 0 101.602 1.199C28.543 23.609 30 19.6 30 15.256c0-4.584-1.611-8.804-4.281-12.125a1 1 0 00-.78-.385zm-4.903 2.9a1 1 0 00-.8 1.627 12.907 12.907 0 01.357 15.49 1 1 0 101.629 1.159A14.92 14.92 0 0024 15.256c0-3.472-1.2-6.67-3.188-9.213a1 1 0 00-.775-.397zM11 7l-4.207 4H3a3 3 0 00-3 3v2a3 3 0 003 3h3.793L11 23V7zm3.738 1.592a1 1 0 00-.736 1.699A7.157 7.157 0 0116 15.256a7.16 7.16 0 01-1.62 4.54 1 1 0 101.552 1.263A9.178 9.178 0 0018 15.256a9.178 9.178 0 00-2.55-6.346 1 1 0 00-.712-.318z'/>
    </svg>
  );
}

export default Icon;
